import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const HeartParticles = () => {
  const [particles, setParticles] = useState([]);
  
  useEffect(() => {
    // Define pet emojis for the celebration effect
    const petEmojis = ['🐾', '🐶', '🐱', '🐰', '🐹', '🐦', '🦮', '🐈', '🐕', '💕'];
    
    // Create random particles
    const particleCount = 15;
    const newParticles = [];
    
    for (let i = 0; i < particleCount; i++) {
      newParticles.push({
        id: `particle-${i}`,
        emoji: petEmojis[Math.floor(Math.random() * petEmojis.length)],
        x: 50 + (Math.random() - 0.5) * 100, // Centered with random offset
        y: 50 + (Math.random() - 0.5) * 100,
        size: Math.random() * 1 + 0.5,
        duration: Math.random() * 2 + 1,
        delay: Math.random() * 0.5
      });
    }
    
    setParticles(newParticles);
  }, []);
  
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute text-sm sm:text-base"
          initial={{ 
            x: '50%', 
            y: '50%', 
            opacity: 0,
            scale: 0
          }}
          animate={{ 
            x: `${particle.x}%`,
            y: `${particle.y - 100}%`, // Move upward
            opacity: [0, 1, 0],
            scale: [0, particle.size, 0],
            rotate: [0, 360]
          }}
          transition={{ 
            duration: particle.duration, 
            delay: particle.delay,
            ease: "easeOut" 
          }}
        >
          {particle.emoji}
        </motion.div>
      ))}
    </div>
  );
};

export default HeartParticles;